import React from 'react';
import { createPortal } from 'react-dom';

import FolderIcon from '@mui/icons-material/Folder';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import UmlShapeWidgetBase from './UmlShapeWidgetBase';

import { JxTooltip, JxTooltipRowItemDescription, JxIconButton } from '@jx';
import { ShapeGeoBuilder } from '@jxUml';

import './UmlPackageWidget.css';

/**
 * Pure painter — no containment logic here see UmlCanvasEngine,
 */
class UmlPackageWidget extends UmlShapeWidgetBase {
    toggleCollapse = (e) => {
        e.stopPropagation();
        const shape = this.props.shape;
        this.props.onShapeCollapseToggled?.(shape.id, !shape.collapsed);
    };

    // this is the resize min size
    getMinSize() {
        const nameLength = this.props.shape.name.length;
        return { width: Math.max(160, nameLength * 8 + 40), height: 60 };
    }

    getEditableZoneClassName() {
        return 'uml-package-widget-title';
    }

    getEditableInputClassName() {
        return 'uml-package-widget-title-input';
    }

    getEditableText() {
        return this.props.shape.name;
    }

    // Title bar is portaled to .uml-package-title-layer (z-index 15, see UmlCanvas.jsx)
    // so it renders ABOVE the connector layer (z-index 10) — connector lines were
    // cutting through package titles otherwise. Body (border/background/resize-handles)
    // stays on the normal package layer (z-index 1), below connectors, unchanged.
    // Same component instance either way — handleDragMouseDown/renderEditableZone keep
    // working identically on the portaled title (drag-by-title, click-to-rename).
    render() {
        const shape = this.props.shape;
        const collapsed = shape.collapsed;
        const effectiveHeight = ShapeGeoBuilder.effectiveHeight(shape);
        const titleContent = (
            <div
                className="uml-package-title-portal"
                data-shape-id={shape.id}
                style={{ left: shape.x, top: shape.y, width: shape.w, zIndex: this.props.stackIndex ?? shape.zIndex }}
                onMouseDown={this.handleDragMouseDown}
            >
                <FolderIcon sx={{ fontSize: 12 }} className="uml-package-widget-type-icon" />
                {this.renderEditableZone(
                    <>
                        {shape.name} - [{shape.children.length}]
                    </>,
                )}
                <JxIconButton
                    className="uml-package-widget-collapse-toggle"
                    icon={collapsed ? <ExpandMoreIcon sx={{ fontSize: 15 }} /> : <ExpandLessIcon sx={{ fontSize: 15 }} />}
                    onMouseDown={(e) => e.stopPropagation()}
                    onClick={this.toggleCollapse}
                    title={collapsed ? 'Expand' : 'Collapse'}
                />
            </div>
        );
        return (
            <>
                <JxTooltip followCursor title={<JxTooltipRowItemDescription label="Press D" value="Delete shape" />}>
                    <div
                        className={`uml-package-widget${this.props.isSelected ? ' uml-selected' : ''}${collapsed ? ' uml-package-widget--collapsed' : ''}`}
                        data-shape-id={shape.id}
                        style={{
                            left: shape.x,
                            top: shape.y,
                            width: shape.w,
                            height: effectiveHeight,
                            zIndex: this.props.stackIndex ?? shape.zIndex,
                        }}
                        onMouseDown={this.handleDragMouseDown}
                    >
                        {!collapsed && this.renderResizeHandles()}
                    </div>
                </JxTooltip>
                {this.props.titleLayerNode && createPortal(titleContent, this.props.titleLayerNode)}
            </>
        );
    }
}

export default UmlPackageWidget;
